import { render, staticRenderFns } from "./WxModalBody.vue?vue&type=template&id=1048a106&scoped=true"
import script from "./WxModalBody.vue?vue&type=script&lang=js"
export * from "./WxModalBody.vue?vue&type=script&lang=js"
import style0 from "./WxModalBody.vue?vue&type=style&index=0&id=1048a106&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1048a106",
  null
  
)

export default component.exports